import type { OrgPlanName } from "@tellescope/tanstack-query";
import type { FeatureName } from "./types";

/**
 * The full table of per-plan, per-feature display-name overrides used by
 * nav/routing to relabel a feature for a given plan. Plans absent from the map
 * (or features absent from a plan's entry) use their default label.
 *
 * Built lazily so the labels are resolved against the current i18n language.
 *
 * @returns A map of plan name to its feature display-name overrides.
 */
export const getFeatureDisplayNames = (): Record<OrgPlanName, Partial<Record<FeatureName, string>>> => {
  return {
    "Healthie-Text": {},
  };
};

/**
 * Per-plan display-name override for a single feature, used by nav/routing to
 * relabel a feature for a given plan. Returns `undefined` when the feature uses
 * its default label or when no plan is provided.
 *
 * @param plan The org's plan (or `undefined`).
 * @param featureName The feature to label.
 * @returns The overridden display name, or `undefined` for the default.
 */
export const getFeatureDisplayName = ({
  plan,
  featureName,
}: {
  plan: OrgPlanName | undefined;
  featureName: FeatureName;
}): string | undefined => (plan ? getFeatureDisplayNames()[plan]?.[featureName] : undefined);
